export default function isNumber(str) {
  if (+str === +str) {
    // if is a number
    return true;
  }
  return false;
}
